export default {
  navText: '導航',
};
